module.exports = __webpack_public_path__ + "static/img/SP图标.477d6ecd.png";